import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { GlobalMessage } from '../../utility/modals';
import { ApplicationconfigurationService } from './applicationconfiguration.service';
import { ApplicationconfigurationmodalComponent } from '../../directives/applicationconfigurationmodal/applicationconfigurationmodal.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';

@Component({
  selector: 'app-applicationconfiguration',
  templateUrl: './applicationconfiguration.component.html',
  styleUrls: ['./applicationconfiguration.component.css']
})
export class ApplicationconfigurationComponent {
  @ViewChild('dt') dt: any;
  tableData: any[] = [];
  selectedItem: MenuItem | null = null;
  commonScrollHeight = '';
  searchText: string;
  ref: DynamicDialogRef | undefined;
  first2: number = 0;
  rows2: number = 10;
  totalRecords: number = 0;
  options = [];
  paginatorArray = []
  visible: boolean = false;
  excel_paragraph = '';
  templatedownloadtext = '';
  exceldownloadModal = false;
  downloadformate = false;
  position = 'top';
  currentPageIndex: number = 0;
  rowsize: number = 10;
  cols = [];
  loginuserid = 0;
  tablecount: number = 0;
  message: GlobalMessage = new GlobalMessage()
  _selectedColumns = [];
  searchTerm: string = ''; 

  constructor(public router: Router, public dialogService: DialogService,
    private orgconfigservice: ApplicationconfigurationService, private utilityservice: Utilityservice,
    private spinner: NgxSpinnerService) {
    this.excel_paragraph = this.message.downloadexcel_text;
    this.templatedownloadtext = this.message.excelformate_text;
    const userdata = this.utilityservice.getLoggeduser();
    this.loginuserid = userdata.userid;
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight()
    this.getgriddata();
    this.dynamiccols();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.commonScrollHeight = this.utilityservice.updateScrollHeight();
  }
  dynamiccols() {
    this.cols = [
      { field: 'mainkey', header: 'Key', type: 'text', sort: true, filter: true, width: '1% !important', isChecked: true, class: 'headerid' },
      { field: 'subkey', header: 'Sub Key', type: 'text', sort: true, filter: true, width: '1% !important', isChecked: true, class: 'headerid' },
      { field: "productinitial", header: "Product", type: 'text', sort: true, filter: true, width: '14%', isChecked: true, class: 'otherheader' },
      { field: "description", header: "Description", type: 'text', sort: true, filter: true, width: '35%  !important', isChecked: true, class: 'otherheader' },
      { field: "keyvalue", header: "Key Value", type: 'text', sort: true, filter: true, width: '30px  !important', isChecked: true, class: 'otherheader' }
      //{ field: "title", header: "Title", type: 'text', sort: true, filter: true, width: '20px', isChecked: true, class: 'otherheader' },
    ]
    this._selectedColumns = this.cols;
  }

  // getgriddata() {
  //   this.spinner.show();
  //   this.orgconfigservice.getgrid().subscribe((data) => {
  //     this.spinner.hide();
  //     this.tableData = data.confdata;
  //     this.options = this.utilityservice.getOptionDropdown(data.confdata.length);
  //     this.paginatorArray = this.options.map(e => e.value)
  //   });
  // } 

  getgriddata() {
    const currentPageSize = this.rowsize;

    this.orgconfigservice.getgrid().subscribe({
      next: (data: any) => {

        const gridData = data.confdata || [];

        this.tableData = gridData.map(item => ({
          ...item,
          isSelect: false
        }));

        this.options = this.utilityservice.getOptionDropdown(gridData.length);
        this.paginatorArray = this.options.map(e => e.value);

        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.rowsize = currentPageSize;
        this.totalRecords = data.totalcount;
        this.tablecount = gridData.length;

        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;
          }
        }, 0);
      },

      error: (error) => {
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error!",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      }
    });
  }

  modalHeight = "100%";
  modalWidth = "90vw";
  show(title, data) {
    if (this.loginuserid != 0) {
      this.modalHeight = "40%";
      this.modalWidth = "50vw"
    }

    let details = {}
    if (title === 'Modify Configuration') {
      this.orgconfigservice.getconfigdetailsbyId(data.configid).subscribe(res => {
        details = res;
        this.ref = this.dialogService.open(ApplicationconfigurationmodalComponent, {
          header: title,
          height: "auto",
          width: this.modalWidth,
          data: { title: title, datas: details },
          contentStyle: {},
          baseZIndex: 10000,
        });
        this.ref.onClose.subscribe(() => {
          this.getgriddata();
        });
      })
    } else {
      details = {}
      this.ref = this.dialogService.open(ApplicationconfigurationmodalComponent, {
        header: title,
        width: '90vw',
        height: 'auto',
        data: { title: title, datas: details },
        contentStyle: { overflow: '' },
        baseZIndex: 10000,
        maximizable: true,
      });
      this.ref.onClose.subscribe(() => {
        this.getgriddata();
      });
    }
  }

  downloadgridexcel() {
    this.orgconfigservice.exceldownload().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Application_Configuration_Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
    }, error => {
      Swal.fire('Something went wrong', '', 'error');

    })
      ;
  }


  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }
  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      // Handling null values
      if (value1 == null && value2 != null) return -1;
      if (value1 != null && value2 == null) return 1;
      if (value1 == null && value2 == null) return 0;

      // Check if the field is createdon for date comparison
      if (event.field === 'createdon') {
        // Parse the date strings to Date objects
        const date1 = new Date(value1);
        const date2 = new Date(value2);
        return date1.getTime() - date2.getTime(); // Sort by timestamp
      }

      // Handle string comparisons
      if (typeof value1 === 'string' && typeof value2 === 'string') {
        return value1.trim().toLowerCase().localeCompare(value2.trim().toLowerCase());
      }

      // Fallback to default number comparison for other types
      return (value1 < value2 ? -1 : (value1 > value2 ? 1 : 0));
    });

    return event.order === -1 ? event.data.reverse() : event.data; // Reverse if descending
  }

  showDialog() {
    let payload = {}
    const width = this.utilityservice.isMobile() ? '90vw' : 'auto';
    this.ref = this.dialogService.open(ExceldownloadComponent, {
      header: "Excel Download",
      width: width,
      height: '10rem',
      data: { excelname: "Application_Configuration_Data.xlsx", downloadapi: 'common/orgconfiguration/exceldownload', method: 'get', message: this.excel_paragraph, payload: payload },
      contentStyle: { overflow: 'hidden' },
      baseZIndex: 10000,
    });
  }

  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }

}



